<template>
  <profile v-if="options.length > 1" class="licenses" :options="options">
    <slot />
  </profile>
  <default v-else>
    <div class="page page--profile mainWrap my-5">
      <div class="row">
        <div class="col-12">
          <slot />
        </div>
      </div>
    </div>
  </default>
</template>

<script lang="ts" setup>
import Profile from "~/components/shared/layout/profile.vue";
import Default from "~/layouts/default.vue";
import { useUserStore } from "~/stores/userstore";
import { useLicensesStore } from "~/stores/licensesstore";
import { PhScroll, PhCertificate, PhUsers, PhBook } from "@phosphor-icons/vue";

const userStore = useUserStore();
const licensesStore = useLicensesStore();

const options = computed(() => {
  const baseOptions = [
    {
      name:
        "My Licenses " +
        (licensesStore.licenseCounts
          ? "(" + licensesStore.licenseCounts?.myLicensesCount + ")"
          : ""),
      link: "/licenses/my-licenses",
      icon: PhScroll,
    },
  ];

  if (userStore.authUser?.companyId) {
    baseOptions.push({
      name:
        "Company Licenses " +
        (licensesStore.licenseCounts
          ? "(" + licensesStore.licenseCounts?.companyLicensesCount + ")"
          : ""),
      link: "/licenses/company-licenses",
      icon: PhCertificate,
    });
  }

  if (userStore.isCompanyAdmin) {
    baseOptions.push({
      name:
        "Member Licenses " +
        (licensesStore.licenseCounts
          ? "(" + licensesStore.licenseCounts?.memberLicensesCount + ")"
          : ""),
      link: "/licenses/member-licenses",
      icon: PhUsers,
    });
  }

  if (userStore.authUser?.companyId) {
    baseOptions.push({
      name: "Journal",
      link: "/licenses/journal",
      icon: PhBook,
    });
  }

  return baseOptions;
});
</script>
<!-- does not work with scoped because the template is defined in profile.vue layout -->
<style lang="scss">
@use "@/sass/layouts/Licenses.scss" as *;
</style>
